import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/sections/Hero";
import Marquee from "../components/sections/Marquee";
import Services from "../components/sections/Services";
import AuditSection from "../components/sections/AuditSection";
import Process from "../components/sections/Process";
import Portfolio from "../components/sections/Portfolio";
import Testimonials from "../components/sections/Testimonials";
import Estimator from "../components/sections/Estimator";
import Pricing from "../components/sections/Pricing";
import FAQ from "../components/sections/FAQ";
import TerrainBackground from "../components/three/TerrainBackground";
import Contact from "../components/sections/Contact";
import { setSeo, setJsonLd } from "../lib/seo";
import { FAQS } from "../data/faqs";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    setSeo();
    setJsonLd("faq-schema", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    setJsonLd("service-schema", {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      name: "vonmal",
      url: "https://vonmal.com/",
      image: "https://vonmal.com/vonmal-developer-header-4096x2304.jpg",
      description:
        "AI software studio building cutting-edge AI apps, agents and websites — fast and affordably.",
      priceRange: "$$",
      areaServed: "Worldwide",
      telephone: "+1-904-789-1050",
      address: [
        { "@type": "PostalAddress", addressLocality: "Jacksonville", addressRegion: "FL", addressCountry: "US" },
        { "@type": "PostalAddress", addressLocality: "Hyderabad", addressCountry: "IN" },
      ],
    });
    const target = location.state?.scrollTo;
    if (target) {
      setTimeout(() => document.getElementById(target)?.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [location.state]);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="min-h-screen relative">
      <TerrainBackground />
      <div className="relative z-10">
        <Navbar />
        <Hero onEstimate={() => scrollTo("estimate")} onAudit={() => scrollTo("audit")} />
        <Marquee />
        <Services />
        <AuditSection />
        <Process />
        <Portfolio />
        <Testimonials />
        <Pricing />
        <Estimator />
        <FAQ />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}
